import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ACTION_CONTAINER: `${cleanedFilename(__filename)}-action-container`,
  ICON_ONLY_BUTTON: `${cleanedFilename(__filename)}-icon-only-button`,
};
